import { BaseAPI } from "./Common";

class ControlledVocabularies extends BaseAPI {
  getManyCountries(): Promise<any> {
    return this.makeRequest(`country/getMany`);
  }
  getManyDosageForms(): Promise<any> {
    return this.makeRequest(`dosageForms/getMany`);
  }
  getManyRouteOfAdministration(): Promise<any> {
    return this.makeRequest(`route-of-administration/getMany`);
  }
  getManyUnitOfMeasurement(): Promise<any> {
    return this.makeRequest(`unit-of-measurement/getMany`);
  }

}

export const controlledVocabularies = new ControlledVocabularies(
  "controlled-vocabularies"
);